// ie: Engine.ui.misc();
jQuery(function ($) {
    "use strict";
    var Engine = {
        ui: {
            misc: function () {
                AOS.init();

                $(function () {

                    $('form[action*="forms.zohopublic.com"]').submit(function (e) {
                        e.preventDefault(); // prevent form submit
                
                        const $form = $(this);
                
                        grecaptcha.ready(function () {
                            grecaptcha.execute('6LcapmsrAAAAAP-3_Umaccw8NnoKIi6vhKBeVF1b', { action: 'submit' }).then(function (token) {
                                $form.find('.g-recaptcha-response').val(token);
                
                                $.ajax({
                                    type: 'POST',
                                    url: '/wp-admin/admin-ajax.php',
                                    dataType: 'json',
                                    data: {
                                        action: 'verify_recaptcha',
                                        token: token
                                    },
                                    success: function (res) {
                                        if (res.success) {
                                            // reCAPTCHA passed — allow submission
                                            $form.off('submit'); // remove preventDefault
                                            $form.submit(); // submit to Zoho
                                        } else {
                                            alert('reCAPTCHA verification failed. Please try again.');
                                        }
                                    },
                                    error: function () {
                                        alert('Something went wrong verifying reCAPTCHA.');
                                    }
                                });
                            });
                        });
                    });

                    // Smooth scroll for anchor links
                    $('a[href^="#"]').on('click', function (e) {
                        e.preventDefault();

                        // Get the target element
                        var target = $(this.hash);
                        if (target.length) {
                            // Animate scroll to target with 100px offset
                            $('html, body').animate({
                                scrollTop: target.offset().top - 100
                            }, 800);

                            // Update URL without the hash
                            if (history.pushState) {
                                history.pushState(null, null, ' ');
                            } else {
                                location.hash = '';
                            }
                        }
                    });

                    let isOpen = false;

                    $("#menuIcon").on('click', function () {
                        if (!isOpen) {
                            // Transition to Close Icon (X)
                            $('.top').attr('d', 'M1 1L19 15');
                            $('.middle').css('opacity', '0');
                            $('.bottom').attr('d', 'M1 15L19 1');
                        } else {
                            // Transition to Hamburger Menu Icon
                            $('.top').attr('d', 'M2 2H25');
                            $('.middle').css('opacity', '1');
                            $('.bottom').attr('d', 'M2 18H25');
                        }

                        isOpen = !isOpen;
                    });

                    const textSwiper = new Swiper('.text-swiper', {
                        direction: 'vertical',
                        effect: 'slide',
                        slidesPerView: "auto",
                        loop: true,
                        centeredSlides: true,
                        autoplay: {
                            delay: 2000,
                            disableOnInteraction: false
                        },
                        speed: 1000,
                        spaceBetween: 10
                    });

                    const numberSwiper = new Swiper('.number-swiper', {
                        slidesPerView: 2,
                        loop: true,
                        spaceBetween: 40,
                        autoplay: {
                            delay: 2000,
                            disableOnInteraction: false
                        },
                        speed: 1000,
                        breakpoints: {
                            768: {
                                slidesPerView: 3,
                                spaceBetween: 100,
                            },
                            1200: {
                                slidesPerView: 4,
                                loop: false,
                                spaceBetween: 100,
                            }
                        }
                    });

                    // $('.freshclean-slider').slick({
                    //     dots: false,
                    //     arrows: true,
                    //     infinite: false,
                    //     slidesToShow: 4,
                    //     slidesToScroll: 1,
                    //     autoplay: true,
                    //     autoplaySpeed: 3000,
                    //     prevArrow: '.freshclean-prev',
                    //     nextArrow: '.freshclean-next',
                    //     responsive: [
                    //         {
                    //             breakpoint: 1280,
                    //             settings: {
                    //                 infinite: true,
                    //                 variableWidth: true,
                    //                 slidesToShow: 1,
                    //             }
                    //         }
                    //     ]
                    // });

                    // Search functionality for the input box
                    $('#search-suburb').on('input', function () {
                        var searchValue = $(this).val().toLowerCase(); // Get the search value and convert to lowercase

                        // Only proceed if the search input is at least two letters
                        if (searchValue.length >= 2) {
                            // Hide all suburb elements initially
                            $('.suburb').hide();

                            // Show the suburb elements that match the search query
                            $('.suburb').filter(function () {
                                return $(this).text().toLowerCase().includes(searchValue);
                            }).show();

                            // Hide the character groups that have no visible suburbs
                            $('[class^="char"]').each(function () {
                                var visibleSuburbs = $(this).find('.suburb:visible').length;

                                if (visibleSuburbs === 0) {
                                    $(this).hide(); // Hide character group if no suburbs are visible
                                } else {
                                    $(this).show(); // Show character group if there are visible suburbs
                                }
                            });
                        } else {
                            // If input length is less than 2, show all suburbs and character groups
                            $('.suburb').show();
                            $('[class^="char"]').show();
                        }
                    });

                    $('.arealist').each(function () {
                        var max = 19;
                        var $suburbs = $(this).find("a.suburb");
                        var $showMore = $(this).siblings('.see-more');

                        // Hide .show-more if there are less than 19 .suburb elements
                        if ($suburbs.length <= max) {
                            $showMore.hide();
                        }

                        // If there are more than max suburbs, hide the extras initially
                        if ($suburbs.length > max) {
                            $suburbs.slice(max).hide();
                        }

                        // Show all suburbs on .show-more click
                        $showMore.on('click', function () {
                            $suburbs.show(); // Show all suburbs
                            $showMore.hide(); // Hide the .show-more button after click
                        });
                    });

                    $(window).on('scroll', function () {
                        if ($(this).scrollTop() > 1000) {
                            $('#back-top').fadeIn();
                            $("#back-top").addClass('active');
                        } else {
                            $('#back-top').fadeOut();
                            $("#back-top").removeClass('active');
                        }
                    });

                    $('#back-top').on('click', function () {
                        $('body,html').animate({
                            scrollTop: 0
                        }, 100);
                        return false;
                    });
                });
            }, // end misc
        }, // end ui
        //utils: {

        //}, // end utils
    };
    Engine.ui.misc();
    //Engine.utils.sliders();
});
